module.exports = __webpack_public_path__ + "img/email.7fb1e499.svg";